import { useUser } from '@clerk/nextjs'
import { PricingStepWrapper } from './pricing-step-wrapper'
import { ArrowRight, Bell, Check, CheckCircle, Star, Unlock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useQuery } from '@tanstack/react-query'

export const PricingStepOne = ({
  setStep,
}: {
  setStep: React.Dispatch<React.SetStateAction<number>>
}) => {
  const { user: clerkUser } = useUser()

  const { data: storedUrl } = useQuery({
    queryFn: () => {
      const value = localStorage.getItem('url')

      if (!value || value.length === 0) {
        return
      }

      return value
    },
  })

  return (
    <PricingStepWrapper motionKey="section-selection">
      <div className="mt-8 md:mt-24 bg-white p-6 md:p-12 drop-shadow-2xl rounded-xl">
        <h1 className="text-2xl text-gray-900">
          <span className="font-bold">Hey {clerkUser?.firstName} 👋</span> <br />
          <span>this is how your free trial will go.</span>
        </h1>
        <ul className="space-y-6 my-12">
          <li className="flex items-center">
            <div className="p-2 bg-sky-50 text-sky-500 rounded-full ">
              <Check className="h-6 w-6 " />
            </div>
            <p className="ml-5">
              <span className="line-through text-sky-500">Signed up</span>
              <br />
              <span className="text-gray-500">Thank you for signing up.</span>
            </p>
          </li>
          <li className="flex items-center">
            <div className="p-2 bg-zinc-50 text-zinc-500 rounded-full ">
              <Unlock className="h-6 w-6 text-sky-500" />
            </div>
            <p className="ml-5">
              <span className=" text-gray-900">Today: Get instant access</span>
              <br />
              <span className="text-gray-500">Up to 100 automated reports.</span>
            </p>
          </li>
          <li className="flex items-center">
            <div className="p-2 bg-zinc-50 text-zinc-500 rounded-full ">
              <Bell className="h-6 w-6 " />
            </div>
            <p className="ml-5">
              <span className=" text-gray-900">Day 3: Trial reminder</span>
              <br />
              <span className="text-gray-500">
                We'll send you an email. Cancel anytime in just 15 seconds.
              </span>
            </p>
          </li>
          <li className="flex items-center">
            <div className="p-2 bg-zinc-50 text-zinc-500 rounded-full ">
              <Star className="h-6 w-6 " />
            </div>
            <p className="ml-5">
              <span className=" text-gray-900">Day 7: Trial ends</span>
              <br />
              <span className="text-gray-500">
                Your subscription will end on{' '}
                {new Date(new Date().setDate(new Date().getDate() + 7)).toLocaleDateString(
                  'en-US',
                  {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  }
                )}
              </span>
            </p>
          </li>
        </ul>
        <div className="w-full flex justify-center">
          <Button
            onClick={() => {
              setStep(1)
            }}
            className="bg-sky-500 hover:bg-sky-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
          >
            <span>Start my 7-day free trial</span>
            <ArrowRight className="ml-2 -mr-1 h-5 w-5" />
          </Button>
        </div>
      </div>
    </PricingStepWrapper>
  )
}
